module.exports = "pegasus/assets/blocks/header-3-tech.png";